import { jsx as s } from "react/jsx-runtime";
import { useChatbotContext as d } from "../../hooks/useChatbotContext.js";
function p({
  children: r,
  suggestion: i = {},
  onClick: t
}) {
  const { isEditing: a, isLoading: n } = d(), { id: o, message: e } = i;
  return /* @__PURE__ */ s(
    "button",
    {
      "data-id": o,
      "data-message": e,
      disabled: a || n || !t,
      className: "inline-block max-w-full animate-fadeIn break-words rounded-medium bg-primary px-[13px] py-[9px] text-base text-primary-foreground ring ring-transparent ring-offset-2 ring-offset-background drop-shadow-[0_15px_25px_rgba(0,0,0,0.02)] transition ease-out hover:bg-primary/90 focus-visible:ring-ring disabled:cursor-wait disabled:opacity-60 disabled:hover:bg-muted disabled:hover:ring-transparent @notMobile:text-sm min-[409px]:max-[409px]:text-sm",
      type: "button",
      onClick: t,
      children: r ?? e
    }
  );
}
export {
  p as SuggestionButton
};
